import { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { Check, Copy } from 'lucide-react';
import { Button, Modal } from '@tes/ui';
import { api } from '../lib/api';
import { isApiStatus, messageOf } from '../lib/errors';

export function ContractPanel({
  templateId,
  onClose,
}: {
  templateId: string;
  onClose: () => void;
}) {
  const { data, isLoading, error } = useQuery({
    queryKey: ['contract', templateId],
    queryFn: () => api.getContract(templateId),
    retry: false,
  });
  const [copied, setCopied] = useState(false);
  const json = data ? JSON.stringify(data, null, 2) : '';

  const copy = async () => {
    await navigator.clipboard.writeText(json);
    setCopied(true);
    setTimeout(() => setCopied(false), 1500);
  };

  return (
    <Modal
      title="Variable contract"
      onClose={onClose}
      size="lg"
      footer={
        data && (
          <Button onClick={copy} variant="secondary">
            {copied ? <Check size={16} className="mr-1" /> : <Copy size={16} className="mr-1" />}
            {copied ? 'Copied' : 'Copy as JSON'}
          </Button>
        )
      }
    >
      {isLoading && <p className="text-sm text-slate-400">Loading…</p>}
      {error && (
        <p className="text-sm text-amber-600">
          {isApiStatus(error, 409)
            ? 'Publish the template first — the contract is derived from the published version.'
            : messageOf(error, 'Could not load the contract.')}
        </p>
      )}
      {data && (
        <pre className="overflow-auto rounded-lg bg-slate-900 p-4 text-xs leading-relaxed text-slate-100">
          {json}
        </pre>
      )}
    </Modal>
  );
}
